import * as React from 'react';

import styles from './ReportPageHeader.module.css';

interface ReportPageHeaderProps {
  title: string;
  date: string;
}

export const ReportPageHeader: React.FC<ReportPageHeaderProps> = ({ title, date }) => (
  <div className={styles.root}>
    <h1 className={styles.title}>{title}</h1>
    {date && (
      <span className={styles.dateCapsule}>
        <i className="fa-regular fa-calendar" />
        {date}
      </span>
    )}
  </div>
);
